import { take, takeEvery, put, fork, all } from 'redux-saga/effects'

import { RECEIVED_RESERVATIONS, STATUS_ACTIVE, STATUS_WAITING_LIST } from 'grs/constants'
import { getReservations } from 'grs/actions'
import getRandomness from 'shared/random-generator'
import { queryPosts } from 'wordpress/actions'
import { POSTS_RECEIVED } from 'wordpress/constants'

import * as constants from './constants'
import * as actions from './actions'

function* recentReservationsSaga() {
    yield takeEvery(constants.GET_RESERVATIONS, function* () {
        const reservationsRequestId = getRandomness()
        const waitingListRecordsRequestId = getRandomness()

        yield put(getReservations(0, 4, STATUS_ACTIVE, reservationsRequestId))
        yield put(getReservations(0, 4, STATUS_WAITING_LIST, waitingListRecordsRequestId))

        const [{ result: reservations }, { result: waitingListRecords }] = yield all([
            take(({ type, requestId }) => type === RECEIVED_RESERVATIONS && requestId === reservationsRequestId),
            take(({ type, requestId }) => type === RECEIVED_RESERVATIONS && requestId === waitingListRecordsRequestId),
        ])

        yield put(actions.setReservations([...reservations, ...waitingListRecords]))
    })
}

function* recentNewsSaga() {
    yield takeEvery(constants.GET_RECENT_NEWS, function* () {
        const requestId = getRandomness()
        yield put(queryPosts('news', { per_page: 2 }, requestId))

        const { result } = yield take(action => action.type === POSTS_RECEIVED && action.requestId === requestId)
        yield put(actions.setRecentNews(result.posts))
    })
}

export default function* rootSaga() {
    yield fork(recentReservationsSaga)
    yield fork(recentNewsSaga)
}
